angular.module("rb.select-all-on-focus",[]).directive("rbSelectAllOnFocus",function(){"use strict";return{restrict:"A",scope:{rbSelectAllOnFocus:"="},link:function(a,b,c,d){b.on("focus",function(){var c=b[0];a.rbSelectAllOnFocus&&angular.isFunction(c.setSelectionRange)&&c.setSelectionRange(0,c.value.length)})}}});
//# sourceMappingURL=rb-select-all-on-focus.min.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-select-all-on-focus/dist/rb-select-all-on-focus.min.js
// module id = OdT9
// module chunks = 0